import { render, staticRenderFns } from "./saleAcount.vue?vue&type=template&id=187b3c4c&scoped=true&"
import script from "./saleAcount.vue?vue&type=script&lang=js&"
export * from "./saleAcount.vue?vue&type=script&lang=js&"
import style0 from "./saleAcount.vue?vue&type=style&index=0&id=187b3c4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187b3c4c",
  null
  
)

export default component.exports